"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setEventAction = exports.removeSpecialCharacters = exports.setTargetURL = exports.clickEvent = exports.readyEvent = exports.impression = exports.isTrackingDisabled = exports.debug = void 0;
exports.defineTrackingService = defineTrackingService;
const v2_1 = require("./v2");
__exportStar(require("./v2/types"), exports);
__exportStar(require("./sanitize"), exports);
var v2_2 = require("./v2");
Object.defineProperty(exports, "debug", { enumerable: true, get: function () { return v2_2.debug; } });
Object.defineProperty(exports, "isTrackingDisabled", { enumerable: true, get: function () { return v2_2.isTrackingDisabled; } });
Object.defineProperty(exports, "impression", { enumerable: true, get: function () { return v2_2.impression; } });
Object.defineProperty(exports, "readyEvent", { enumerable: true, get: function () { return v2_2.readyEvent; } });
Object.defineProperty(exports, "clickEvent", { enumerable: true, get: function () { return v2_2.clickEvent; } });
Object.defineProperty(exports, "setTargetURL", { enumerable: true, get: function () { return v2_2.setTargetURL; } });
Object.defineProperty(exports, "removeSpecialCharacters", { enumerable: true, get: function () { return v2_2.removeSpecialCharacters; } });
Object.defineProperty(exports, "setEventAction", { enumerable: true, get: function () { return v2_2.setEventAction; } });
const optionalDependencies = {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    's2:logger': '^1.0.0',
};
/**
 * This feature service provides tracking functionality to feature apps.
 */
function defineTrackingService(trackingProvider) {
    return {
        id: 'audi-tracking-service',
        optionalDependencies: {
            featureServices: optionalDependencies,
        },
        create(env) {
            const { datalayer = {}, sanitizeUrl, primaryConsumerId } = trackingProvider;
            if (!datalayer || !sanitizeUrl) {
                throw new Error(`The tracking Service is not properly configured. datalayer: ${datalayer}, sanitizeUrl: ${sanitizeUrl}`);
            }
            // The global service is featureApp independent and has no state. It can be instantiated once.
            const globalTrackingServiceV2 = new v2_1.SharedTrackingServiceV2(datalayer, sanitizeUrl, env.featureServices['s2:logger'] || console, primaryConsumerId);
            return {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                '2.2.0': (consumerId) => {
                    const featureService = new v2_1.ConsumerTrackingServiceV2(globalTrackingServiceV2, consumerId);
                    return {
                        featureService,
                        unbind: () => featureService.unbind(),
                    };
                },
            };
        },
    };
}
//# sourceMappingURL=index.js.map